import React, { useState } from "react";
import { Datepicker } from "flowbite-react";
import { Button } from "flowbite-react";
import axios from "axios";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ConfirmDialog from "../ConfirmDialog";
import LoadingOverlay from "../LoadingOverlay";
import { tr } from "date-fns/locale";

function FinishGoodModal({ isVisible, onClose, orderData, refreshOrders }) {
  const [dlvrDate, setDlvrDate] = useState("");
  const [finQty, setFinQty] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadPending, setUploadPending] = useState(false);
  const navigate = useNavigate();

  if (!isVisible) return null;

  const handleFGInputDateChange = (date) => {
    setDlvrDate(format(new Date(date), "yyyy-MM-dd"));
  };

  const handleFinQtyChange = (e) => {
    setFinQty(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!dlvrDate) {
      toast.error("Pilih tanggal selesai.");
      return;
    }
    if (!finQty) {
      toast.error("Masukan total QTY");
      return;
    }
    setUploadPending(true); // Intent to upload
    setShowConfirm(true); // Show confirmation modal
  };

  const finishOrder = async () => {
    setIsLoading(true);
    try {
      await axios.post(`https://eps.elkomprintama.com/post/api/fin_orders/`, {
        custId: orderData.cust_id,
        jobId: orderData.job_id,
        date: format(new Date(orderData.date), "yyyy-MM-dd"), // 🛠 format
        qty: orderData.qty,
        poNum: orderData.po_num,
        dlvry: format(new Date(orderData.dlvr_date), "yyyy-MM-dd"), // 🛠 format
        opr: orderData.opr_id,
        qc: orderData.qc_id,
        fdate: dlvrDate, // this should already be formatted
        fqty: finQty,
        orderId: orderData.order_id,
      });
      toast.success("success");
      if (refreshOrders) refreshOrders(); // 🔁 call to re-fetch!
      onClose();
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.msg);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <div className="fixed inset-0 bg-black bg-opacity-25 backdrop-blur-sm flex flex-col justify-center items-center">
        <div className=" bg-white w-full max-w-2xl  rounded-lg flex flex-col">
          <form className="w-full max-w-2xl p-10 " onSubmit={handleSubmit}>
            <p className="text-center text-3xl font-bold mb-5 ">
              Move to Finish Goods?
            </p>
            <div className="flex flex-wrap -mx-3 mb-5">
              <div className="w-full md:w-1/2 px-3">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="grid-finish-date"
                >
                  Finish Date
                </label>
                <Datepicker
                  id="grid-finish-fgdate"
                  name="grid-finish-fgdate"
                  onSelectedDateChanged={handleFGInputDateChange}
                  value={dlvrDate}
                  dateFormat="dd/MM/yyyy"
                />
              </div>
              <div className="w-full md:w-1/2 px-3">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="finishqty"
                >
                  Finish Qty
                </label>
                <input
                  onChange={handleFinQtyChange}
                  className="appearance-none block w-full bg-white text-black border border-gray-300 rounded py-3 px-4 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
                  id="finishqty"
                  name="finishqty"
                  type="text"
                  placeholder="Qty"
                />
              </div>
            </div>
            <div className="w-full space-y-3">
              <Button fullSized type="submit" color="blue">
                Submit
              </Button>
              <Button
                fullSized
                onClick={onClose}
                className="bg-red-600 hover:bg-red-700 text-white"
              >
                Close
              </Button>
            </div>
            {isLoading && <LoadingOverlay message="Loading" />}
            {showConfirm && uploadPending && (
              <ConfirmDialog
                message="Konfirmasi apakah produk sudah selesai"
                onConfirm={() => {
                  setShowConfirm(false);
                  finishOrder();
                }}
                onCancel={() => {
                  setShowConfirm(false);
                  setUploadPending(false);
                }}
              />
            )}
          </form>
        </div>
      </div>
    </div>
  );
}

export default FinishGoodModal;
